import { RequestService } from '../../../../common/services/RequestService';
import { UPDATE_EXECUTOR, UPLOAD_PHOTO_COMPANY_EXECUTOR } from '../constants';
import { adjustExecutor, adjustExecutorSend } from './adjustExecutorById';
// todo требуется рефакторинг
export const updateExecutorRequest = async (profileId, data) => {
  const sendPhoto = async (executorId, companyPhoto) => {
    let uploadPhoto = companyPhoto;
    const formData = new FormData();
    if (typeof uploadPhoto === 'object' && uploadPhoto instanceof File) {
      formData.append(`image_file`, uploadPhoto);
      formData.append(`company_id`, executorId);
    } else {
      uploadPhoto = null;
    }
    if (uploadPhoto) {
      try {
        return await RequestService.post(
          UPLOAD_PHOTO_COMPANY_EXECUTOR,
          formData
        );
      } catch (error) {
        console.log(error);
      }
    }
    return null;
  };
  const [response, resPhoto] = await Promise.all([
    RequestService.put(
      UPDATE_EXECUTOR.replace('{profile_id}', profileId).replace(
        '{company_id}',
        data.executorId
      ),
      adjustExecutorSend(profileId, data)
    ),
    sendPhoto(data.executorId, data.companyPhoto),
  ]);
  if (resPhoto && resPhoto.data && resPhoto.data.url && response.data) {
    response.data.picture = resPhoto.data.url;
  }
  return response.data && adjustExecutor(response.data);
};
